import { IReactionDisposer, when } from 'mobx';
import isUndefined from 'lodash/isUndefined';
import { CommonThumbnailLogic } from '@src/slide/content-viewer/service/canvas-renderer/entry/thumbnail/logic/common-thumbnail-logic';
import type { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import type { ComponentFactory } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/component-factory';
import { isIframeShapeModel } from '@src/slide/domain/ui-model/elements/element-judge';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';

export class ShapeThumbnailLogic extends CommonThumbnailLogic {
    public iframePosterListener: IReactionDisposer;

    public constructor(factoryOptions: InterfaceFactoryOptions<IShapeModel>, component: ComponentFactory) {
        super(factoryOptions, component);

        if (isIframeShapeModel(this.factoryOptions.model)) {
            this.addiframePosterListener();
        }
    }

    private addiframePosterListener = () => {
        const { model } = this.factoryOptions;

        this.iframePosterListener = when(
            () => !isUndefined(this.factoryOptions.mediaManager?.iframePosterCaches.get(model.key)),
            () => {
                this.component.updateComponent();
            },
        );
    };
}
